export default "__VITE_ASSET__BBmtsR3z__"